import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Text } from 'src/components/common';
import { Modal } from 'src/components/Modal';
import { scheduleDepositionAction } from 'src/redux/scheduleDepositionRedux';
import { UpdateScheduleDepositionPayload } from 'src/redux/scheduleDepositionRedux/types';
import { ErrorService, Toastify } from 'src/services';
import { IAppState } from 'src/store';
import { ISchedulingDepositions } from '../type';
import EditSubmission from './EditSubmission';
import './styles.scss';
import SubmissionDetails from './SubmissionDetails';

const Submission: React.VFC<Props> = ({
  isLoading,
  onClose,
  record,
  onUpdateScheduleDeposition,
  onInitialDeposition,
}) => {
  const [mode, setMode] = React.useState<'details' | 'edit'>('details');
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const handleOnEditButton = () => {
    setMode('edit');
  };

  const handleOnCancelEditButton = () => {
    setMode('details');
  };

  const handleSubmit = (formProps: ISchedulingDepositions) => {
    setIsSubmitting(true);
    const date: string = moment(formProps.depositionDate).format('YYYY-MM-DD');
    const time: string = moment(formProps.depositionTime, 'hh:mm a').format('HH:mm');
    const dateTime: string = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').format();
    const body: UpdateScheduleDepositionPayload = {
      name: formProps.name,
      email: formProps.email,
      lawFirm: formProps.lawFirm,
      phoneNumber: formProps.phoneNumber,
      attorneyName: formProps.attorneyName,
      depositionDate: dateTime,
      depositionLocation: formProps.depositionLocation,
      city: formProps.city,
      isNeedConferenceRoom: formProps.isNeedConferenceRoom,
      caseName: formProps.caseName,
      deponent: formProps.deponent,
      additionalNotes: formProps.additionalNotes,
    };
    onUpdateScheduleDeposition({ body: body, uri: formProps.uri }, handleSubmitSuccess, handleActionFailed);
  };

  const handleSubmitSuccess = (res: any) => {
    setIsSubmitting(false);
    Toastify.success('Schedule Request has been updated successfully!');
    onClose();
  };

  const handleActionFailed = (error: any) => {
    setIsSubmitting(false);
    ErrorService.handler(error);
  };

  return (
    <Modal onModalClosed={onClose}>
      <Text variant="title" className="mb-16" size={24}>
        {mode === 'details' ? 'Submission Details' : mode === 'edit' ? 'Edit Submission' : ''}
      </Text>
      {mode === 'details' && (
        <SubmissionDetails
          scheduleDepositionItem={record}
          onNext={handleOnEditButton}
          onInitialDeposition={onInitialDeposition}
        />
      )}
      {mode === 'edit' && (
        <EditSubmission
          scheduleDepositionItem={record}
          onCancel={handleOnCancelEditButton}
          onSave={handleSubmit}
          loading={isSubmitting}
        />
      )}
    </Modal>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onClose: (...arg: any[]) => void;
    record: ISchedulingDepositions;
    onInitialDeposition: (...arg: any[]) => void;
  };

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
});

const mapDispatchToProps = {
  onUpdateScheduleDeposition: scheduleDepositionAction.updateScheduleDeposition,
};

export default connect(mapStateToProps, mapDispatchToProps)(Submission);
